import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Select, Button, Input, AsyncSelect } from '../../ui';
import Continue from '../../Common/Continue';
import { validateEmail, validateDate, justNumbers, mapSelectList } from '../../../helpers';

import { setClientValue, setRentalValue } from '../../../actions';
import { emptyApplicant } from '../../../reducers/rental'
import { options } from '../../../operations';

import Form from './Form.styles';

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import iconCalendar from '../../../assets/icons/icon-calendar-blue.svg';
import iconGender from '../../../assets/icons/icon-gender.svg';
import iconPhone from '../../../assets/icons/icon-phone.svg';
import { getStreetsAsync } from '../../../operations/options';

const coSolicitanteText = `El 'Co-Solicitante' es quién junto con el inquilino, participa de los derechos y obligaciones que surgen del contrato de alquiler. Se compromete junto con el inquilino, al pago en tiempo y forma de los importes de alquiler, gastos comunes, etc. y la vez adquiere los mismos derechos de usufructo del inmueble (puede o no ejercer este derecho).`;

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

const MinusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

function PersonalData(props) {
  const {
    showError,
    departments,
    cities,
    onDepartmentChange,
    onCityChange,
    onStreetChange,
    addressState,
    addressCity,
    addressStreet,
    addressNumber,
    applicants,
    onRentalValueChange,
    getDepartments
  } = props;

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const validatedCondition = () => {
      const {
        applicants
      } = props;

      function validateApplicant(applicant) {
        const {
          name,
          lastName,
          email,
          nationality,
          documentType,
          documentNumber,
          phoneNumber,
          mobileNumber,
          dateOfBirth,
          gender,
          civilStatus,
          addressState,
          addressCity,
          addressStreet,
          addressNumber,
          addressApto
        } = applicant;

        /**
         * NOTE: Si se cambia un campo obligatorio recordar cambiar (*) en el placeholder
         */
        return (
          name != '' &&
          lastName != '' &&
          email != '' &&
          validateEmail(email) &&
          nationality != '' &&
          documentType != null &&
          documentNumber != '' &&
          mobileNumber != '' &&
          dateOfBirth != '' &&
          validateDate(dateOfBirth) &&
          gender != null &&
          civilStatus != null &&
          addressState != null &&
          addressCity != null &&
          addressStreet != null
        )
      }

      for (let i = 0; i < applicants.length; i++) {
        const applicant = applicants[i];

        if (!validateApplicant(applicant)) {
          return false;
        }
      }

      return true;
    }

    setValidated(validatedCondition());
  }, [props]);

  useEffect(() => {
    getDepartments();
  }, [getDepartments]);

  const onChangeApplicantValue = (index, type, value) => {
    const data = [...applicants];
    data[index][type] = value;
    onRentalValueChange('applicants', data);
  }

  /**
   * NOTE:
   *
   * Para los datos de dirección se siguen usando los valores
   * de `client` pero luego se cargan en el array de `applicants`.
   *
   * Esto permite reutilizar las operaciones sin cambiar nada.
   */

  const onChangeApplicantAddress = (index, name, value) => {
    switch (name) {
      case 'addressState':
        onDepartmentChange(value);
        break;
      case 'addressCity':
        onCityChange(value);
        break;
      case 'addressStreet':
        onStreetChange(value);
        break;

      default:
        break;
    }

    onChangeApplicantValue(index, name, value);
  }

  const addApplicant = () => {
    onRentalValueChange('applicants', [
      ...applicants,
      { ...emptyApplicant }
    ]);
  }

  const removeApplicant = (index) => {
    const newList = [...applicants]
    newList.splice(index, 1);
    onRentalValueChange('applicants', [...newList]);
  }

  return (
    <Form>
      <div className="Form-title">Completa los siguientes campos</div>

      {applicants.map((applicant, index) => (
        <div key={index}>
          <div className="Form-subtitle">
            {index === 0 ? (
              <h3>Solicitante</h3>
            ): (
              <h3>Co-solicitante {index}</h3>
            )}

            <div>
              {(index !== 0) && (
                <Button terciary onClick={() => removeApplicant(index)} style={{ marginRight: '1rem' }}>
                  <MinusIcon />
                  <span>Eliminar co-solicitante</span>
                </Button>
              )}

              {(index === applicants.length - 1) && (applicants.length < 3) && (
                <Button secondary title={coSolicitanteText} onClick={addApplicant}>
                  <PlusIcon />
                  <span>Agregar co-solicitante</span>
                </Button>
              )}
            </div>
          </div>
          <div className="Form-row">
          <div className="Form-col">
          <div className="Form-group">
            <Input
              id="name"
              name="name"
              placeholder="Nombre (*)"
              maxLength="50"
              type="text"
              leftIcon={iconUser}
              autoComplete="nope"
              value={applicants[index].name}
              onChange={(event) => { onChangeApplicantValue(index, 'name', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Input
              id="lastName"
              name="lastName"
              placeholder="Primer apellido (*)"
              maxLength="50"
              type="text"
              leftIcon={iconUser}
              autoComplete="nope"
              value={applicants[index].lastName}
              onChange={(event) => { onChangeApplicantValue(index, 'lastName', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Input
              id="motherLastName"
              name="motherLastName"
              placeholder="Segundo apellido"
              maxLength="50"
              type="text"
              leftIcon={iconUser}
              autoComplete="nope"
              value={applicants[index].motherLastName}
              onChange={(event) => { onChangeApplicantValue(index, 'motherLastName', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Input
              id="nationality"
              name="nationality"
              placeholder="Nacionalidad (*)"
              maxLength="50"
              type="text"
              leftIcon={iconUser}
              autoComplete="nope"
              value={applicants[index].nationality}
              onChange={(event) => { onChangeApplicantValue(index, 'nationality', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Select
              id="documentType"
              name="documentType"
              placeholder="Tipo de documento (*)"
              options={[
                { label: 'C.I. Uruguaya', value: 1 }
              ]}
              leftIcon={iconNumber}
              value={applicants[index].documentType}
              onChange={(value) => { onChangeApplicantValue(index, 'documentType', value) }}
            />

          </div>

          <div className="Form-group">
            <Input
              id="documentNumber"
              name="documentNumber"
              placeholder="Número de documento (*)"
              maxLength="50"
              type="text"
              leftIcon={iconNumber}
              autoComplete="nope"
              value={applicants[index].documentNumber}
              onChange={(event) => { onChangeApplicantValue(index, 'documentNumber', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Input
              id="mobileNumber"
              name="mobileNumber"
              placeholder="Celular (*)"
              maxLength="50"
              type="tel"
              leftIcon={iconPhone}
              autoComplete="nope"
              value={applicants[index].mobileNumber}
              onChange={(event) => { justNumbers(event.target.value) && onChangeApplicantValue(index, 'mobileNumber', event.target.value) }}
            />
          </div>

          <div className="Form-group">
            <Input
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Teléfono fijo"
              maxLength="50"
              type="tel"
              leftIcon={iconPhone}
              autoComplete="nope"
              value={applicants[index].phoneNumber}
              onChange={(event) => { justNumbers(event.target.value) && onChangeApplicantValue(index, 'phoneNumber', event.target.value) }}
            />
          </div>
        </div>
          <div className="Form-col">
          <div className="Form-group">
            <Input
              id="email"
              name="email"
              placeholder="Email  (*)"
              maxLength="50"
              type="email"
              leftIcon={iconEmail}
              autoComplete="nope"
              value={applicants[index].email}
              onChange={(event) => { onChangeApplicantValue(index, 'email', event.target.value) }}
              showAlert={applicants[index].email !== '' && !validateEmail(applicants[index].email)}
            />
          </div>

          <div className="Form-group">
            <Input
              id="dateOfBirth"
              name="dateOfBirth"
              placeholder="Fecha de nacimiento (*)"
              maxLength="50"
              type="text"
              leftIcon={iconCalendar}
              autoComplete="nope"
              value={applicants[index].dateOfBirth}
              onChange={(event) => { onChangeApplicantValue(index, 'dateOfBirth', event.target.value) }}
              showAlert={applicants[index].dateOfBirth !== '' && !validateDate(applicants[index].dateOfBirth)}
            />
          </div>

          <div className="Form-group">
            <Select
              id="gender"
              name="gender"
              placeholder="Género (*)"
              options={[
                { label: 'Masculino', value: 'M' },
                { label: 'Femenino', value: 'F' },
                { label: 'Otro', value: 'O' },
              ]}
              label="Género"
              leftIcon={iconGender}
              value={applicants[index].gender}
              onChange={(event) => { onChangeApplicantValue(index, 'gender', event) }}
            />
          </div>

          <div className="Form-group">
            <Select
              id="civilStatus"
              name="civilStatus"
              placeholder="Estado civil (*)"
              options={[
                { label: 'Soltero/a', value: 1 },
                { label: 'Casado/a', value: 2 }
              ]}
              label="Estado civil"
              leftIcon={iconUser}
              value={applicants[index].civilStatus}
              onChange={(event) => { onChangeApplicantValue(index, 'civilStatus', event) }}
            />
          </div>

          <div className="Form-group">
            <Select
              id="addressState"
              leftIcon={iconNumber}
              name="addressState"
              value={applicants[index].addressState}
              onChange={(value) => onChangeApplicantAddress(index, 'addressState', value)}
              placeholder="Seleccione un departamento (*)"
              options={mapSelectList(departments)}
            />
          </div>

          <div className="Form-group">
            <Select
              id="addressCity"
              leftIcon={iconNumber}
              name="addressCity"
              value={applicants[index].addressCity}
              onChange={(value) => onChangeApplicantAddress(index, 'addressCity', value)}
              placeholder="Seleccione una ciudad (*)"
              options={mapSelectList(cities)}
              noOptionsMessage={() =>
                'Sin ciudades. Seleccione el Departamento primero.'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>

          <div className="Form-group">
            <AsyncSelect
              id="addressStreet"
              leftIcon={iconUser}
              name="addressStreet"
              value={applicants[index].addressStreet}
              onChange={(value) => onChangeApplicantAddress(index, 'addressStreet', value)}
              placeholder="Seleccione una calle (*)"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={addressStreet === ''}
              disabled={addressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>

          <div className="Form-group">
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={applicants[index].addressNumber}
              onChange={(event) => { onChangeApplicantValue(index, 'addressNumber', event.target.value) }}
              leftIcon={iconNumber}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />
          </div>

          <div className="Form-group">
            <Input
              id="addressApto"
              name="addressApto"
              placeholder="Nro. de apto"
              maxLength="10"
              type="text"
              value={applicants[index].addressApto}
              onChange={(event) => {
                justNumbers(event.target.value) && onChangeApplicantValue(index, 'addressApto', event.target.value)
              }}
              leftIcon={iconNumber}
              autoComplete="nope"
            />
          </div>
        </div>
        </div>
        </div>
      ))}

      <Continue state={validated} />
    </Form>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    name: state.client.name,
    lastName: state.client.lastName,
    gender: state.client.gender,
    email: state.client.email,
    phoneNumber: state.client.phoneNumber,
    mobileNumber: state.client.mobileNumber,

    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,

    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets,

    applicants: state.rental.applicants
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onRentalValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    },
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onDepartmentChange: addressState => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: addressCity => {
      dispatch(options.setCity(addressCity));
    },
    onStreetChange: addressStreet => {
      dispatch(setClientValue('addressStreet', addressStreet));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalData);
